/**
 * @file ほかの端末と同じページを開く連動の切り替え (チェックボックス) である。
 *
 * @what: 入れると、この端末はほかの端末で開いた本とページへついていき、自分で開いた本とページを
 *   ほかの端末へ知らせる。切り替えは端末ごとに覚え、最初は切れている (lib/deviceSync.ts)。
 *   本を読む画面のメニューと、本だなの上部に置く。
 * @why: 最初を切っておくのは、保護者が PC でお子さんの本だなを見て本を開いただけで、勉強中の
 *   お子さんの iPad の画面が切り替わらないようにするためである (代表の判断、2026-10-10)。
 * @failure: なし (覚えられない端末では、読み込み直すと切れている)。
 */

import { setDeviceSyncEnabled, useDeviceSyncEnabled } from "../lib/deviceSync";

export function DeviceSyncToggle({ className }: { className?: string }) {
  const on = useDeviceSyncEnabled();
  return (
    <label className={className ? `study-device-sync ${className}` : "study-device-sync"}>
      <input
        type="checkbox"
        checked={on}
        onChange={(e) => setDeviceSyncEnabled(e.target.checked)}
      />
      <span>
        ほかの端末と同じ
        <wbr />
        ページを開く
      </span>
    </label>
  );
}
